<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<a id="title1"><h1 class="title">ACKNOWLEDGMENTS</h1>
<p class="p"><span>We are indebted to the generosity of many postcard collectors who graciously shared their collections with us. Some are friends we have known for a long time (and bid against at auctions). Others are people we had never before met but who answered our call for postcards. Still others include eBay sellers who e-mailed us scans of cards when we somewhat sheepishly asked. Without their contributions, this book, and a possible Martinsville book to come, would never have come to life. Thank you to the following people, institutions, and organizations: Academy of Hoosier Heritage, Dianna Atkins, Cathy Counsilman Bonner, Del Chafey, Irma S. Coates, Ruth Connell, Michael Gorham, Sharon Platt Kain, Kevin Kent, Bill Kirk, Pam Lanham, Peggy LaPlante, Mooresville Public Library, Morgan County Historic Preservation Society, Morgan County Public Library, Tim and Camilla Morris, Don and Joyce Robinson, Joe Seiter, Harley Sheets, Keith Steinway, Joanne Raetz Stuttgen, Curtis Tomak, Frances Tutterow, Donna Walker, and Jeanne Weaver.</span></p>
<p class="p-indent"><span>Furthermore, we are beholden to the following local residents and historians whose passion for and commitment to preserving and recording the past have enriched this book immeasurably: Albert “Dutch” Allen, Stella Aver y, Janet Cowen, Alma Fraker, Patsy Harker Freed, Mae Gano, Almira Harvey Hadley, Gordon Hadley, Becky Hardin, Lena Hensley, Henrietta Hickman, John E. Hurt Sr., Lloyd James, Noble K. Littell, Don and Donna McGuire, Mary E. Monical, Charlie Nelson, Wanda Potts, Robert Prather, Claude M. Renner, Clara S. Richardson, Rachel Ruona, Margaret Sedwick, Mary E. Murphy Taylor, Phyllis Walker, Jeanne Weaver, and Henry Youngblood.</span></p></a></div><a id="title1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439634974_ack01.vue?024f64c1